import { mudwaterEvmChainConfig } from "@/lib/mudwater";

/** The EIP-1193 rejection code the wallet UI distinguishes. */
const USER_REJECTED = 4001;

function walletErrorCode(error: unknown): number | undefined {
  if (typeof error !== "object" || error === null || !("code" in error))
    return undefined;
  const code = error.code;
  return typeof code === "number" ? code : undefined;
}

/**
 * Rendered verbatim by the wallet dialog, so keep the wording stable. wagmi's
 * `switchChain` falls back to `wallet_addEthereumChain` on 4902, so adding and
 * switching are one call and need only this one message pair.
 */
export function chainSwitchError(error: unknown): Error {
  if (walletErrorCode(error) === USER_REJECTED)
    return new Error(
      `Allow the wallet to switch to ${mudwaterEvmChainConfig.chainName}.`,
      { cause: error }
    );
  // The wallet's own error rides along as the cause, so telemetry can say why:
  // one iOS holder failed this five times on 2026-10-21 with no reason recorded.
  return new Error(
    `Your wallet could not switch to ${mudwaterEvmChainConfig.chainName}. Try again.`,
    { cause: error }
  );
}
